/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCallDealerCta_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly " $refType": "PdpSharedCallDealerCta_user";
};
export type PdpSharedCallDealerCta_user$data = PdpSharedCallDealerCta_user;
export type PdpSharedCallDealerCta_user$key = {
    readonly " $data"?: PdpSharedCallDealerCta_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedCallDealerCta_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedCallDealerCta_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '86b13761a04eb4c8578a1d05709eb0e0';
export default node;
